export default [
  {
    path: 'helpdesk',
    name: 'HelpDesk',
    component: () => import('@/views/helpdesk/Wrapper'),
    children: [
      {
        path: '',
        name: 'CaseListMain',
        component: () => import('@/views/helpdesk/Search/Main.vue'),
      },
      {
        path: '/helpdesk/create',
        name: 'CreateTicket',
        component: () => import('@/views/helpdesk/Manage/Main.vue'),
      },
      {
        path: '/helpdesk/details/:id',
        name: 'DetailsTicket',
        component: () => import('@/views/helpdesk/Manage/Main.vue'),
      },
    ],
  },
];
